import useThrowAsyncError from '../../../../../hooks/useThrowAsyncError';
import { getFileTypeDescription } from '../../../../../utils/fileType';
import JWPlayerModal from '../../components/modals/JWPlayerModal';
import { FileUserMaterial, getSignedUrl } from '../../../../../api/user-material';
import PdfPreviewModal from '../../components/modals/PdfPreviewModal';
import TableOfContentsContext from '../../_contexts/TableOfContentsContext';
import { useContext } from 'react';
import { UserMaterialDialogHeaderTags } from '../../../components/UserMaterialDialogHeaderTags';
import IdentityContext from '../../../../../contexts/IdentityContext';
import ImagePreviewModal from '../../components/modals/ImagePreviewModal';
import NoPreviewModal from '../../components/modals/NoPreviewModal';

export default function useFileUserMaterial() {
  const handleError = useThrowAsyncError();
  const { nodes } = useContext(TableOfContentsContext);
  const { identity } = useContext(IdentityContext);

  async function openFileUserMaterial(material: FileUserMaterial) {
    try {
      const { url, downloadUrl, previewUrl } = await getSignedUrl(material.moduleId, material.id);

      if (previewUrl) {
        return (
          <PdfPreviewModal
            id="pdf-preview-modal"
            url={previewUrl}
            downloadUrl={downloadUrl}
            headerProps={{
              title: material.name,
              titleTooltip: material.name,
              tags: (
                <UserMaterialDialogHeaderTags
                  material={material}
                  nodes={nodes}
                  isTeacherAlike={identity.isTeacherAlike}
                />
              ),
            }}
          />
        );
      }

      const fileType = getFileTypeDescription(material.file.mimeType).key;

      switch (fileType) {
        case 'AUDIO':
        case 'VIDEO':
          return (
            <JWPlayerModal
              id={`jwplayer-${fileType.toLocaleLowerCase()}-modal`}
              media={{ file: url }}
              downloadUrl={downloadUrl}
              headerProps={{
                title: material.name,
                titleTooltip: material.name,
                tags: (
                  <UserMaterialDialogHeaderTags
                    material={material}
                    nodes={nodes}
                    isTeacherAlike={identity.isTeacherAlike}
                  />
                ),
              }}
              audioOnly={fileType === 'AUDIO'}
            />
          );
        case 'IMAGE':
          return (
            <ImagePreviewModal
              id="image-preview-modal"
              downloadUrl={downloadUrl}
              image={{
                src: url,
                alt: material.name,
              }}
              headerProps={{
                title: material.name,
                titleTooltip: material.name,
                tags: (
                  <UserMaterialDialogHeaderTags
                    material={material}
                    nodes={nodes}
                    isTeacherAlike={identity.isTeacherAlike}
                  />
                ),
              }}
            />
          );
      }

      return (
        <NoPreviewModal
          id="no-preview-modal"
          downloadUrl={downloadUrl}
          headerProps={{
            title: material.name,
            titleTooltip: material.name,
            tags: (
              <UserMaterialDialogHeaderTags
                material={material}
                nodes={nodes}
                isTeacherAlike={identity.isTeacherAlike}
              />
            ),
          }}
        />
      );
    } catch (error) {
      handleError(error);
    }
  }

  return { openFileUserMaterial };
}
